import React from "react";
import { preaddStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { TextFieldComponent } from "../form/textFeild";
import { FormSelect } from "../form";

export const AddSchoolForm = ({
  name,
  address,
  description,
  vat,
  paynestFee,
  handleChange,
  merchantId,
  payeeType,
  errors
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();
  const personal_Details = {
    fontWeight: 500,
    fontSize: "15px",
    color: "rgb(13, 110, 124)",
    marginBottom: "15px"
  };

  const PAYEE_TYPE_LIST = [
    {
      value: "STUDENT",
      label: t("text_student"),
    },
    {
      value: "PARENT",
      label: t("text_parent"),
    }
  ];

  return (
    <div className={classes.addSchoolForm}>
      <h5 style={personal_Details}>
        <strong>{t("text_school_details")}</strong>
      </h5>
      <Grid container className={classes.gridRoot} spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            errorMessage={errors.indexOf("name") > -1 === true && t("text_school_name") + ' ' + t("text_is_required")}
            required={true}
            error={errors.indexOf("name") > -1}
            value={name}
            onChange={handleChange}
            label={t("text_school_name")}
            name={"name"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={errors.indexOf("address") > -1 === true && t("text_school_address") + ' ' + t("text_is_required")}
            error={errors.indexOf("address") > -1}
            value={address}
            onChange={handleChange}
            label={t("text_school_address")}
            name={"address"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            value={description}
            onChange={handleChange}
            label={t("text_description")}
            name={"description"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={errors.indexOf("merchantId") > -1 === true && t("text_merchant_id") + ' ' + t("text_is_required")}
            error={errors.indexOf("merchantId") > -1}
            value={merchantId}
            onChange={handleChange}
            label={t("text_merchant_id")}
            name={"merchantId"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={errors.indexOf("vat") > -1 === true && t("text_vat") + ' ' + t("text_is_required")}
            error={errors.indexOf("vat") > -1}
            value={vat}
            onChange={handleChange}
            label={t("text_vat")}
            name={"vat"}
            type="number"
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            value={paynestFee}
            onChange={handleChange}
            label={t("text_paynest_fee")}
            name={"paynestFee"}
            type="number"
          />
        </Grid>

        <Grid item sm={6} xs={12}>
              <FormSelect
                value={payeeType}
                onChange={handleChange}
                label={t("text_payee_type")}
                name={"payeeType"}
                list={PAYEE_TYPE_LIST}
              />
            </Grid>
      </Grid>
    </div>
  );
};
